import {AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild,} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {UsineInfo} from '../../../../../../domain/fournisseur/UsineInfo';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {
    SelectCodepostalComponent
} from '../../../../../../modules/widget/components/form/select/select-codepostal/select-codepostal.component';

export interface DialogDataUsine {
    usines: UsineInfo;
}

type fileds = keyof UsineInfo;

@Component({
    selector: 'app-add-dialog-usine',
    templateUrl: './add-dialog-usine.component.html',
    styleUrls: ['./add-dialog-usine.component.css'],
})
export class AddDialogUsineComponent implements OnInit, AfterContentChecked {
    @ViewChild(SelectCodepostalComponent) selectCodepostalComponent;
    filed = {
        tel_num: 'telNo',
        fax: 'faxNo',
        codepostale: 'postCd',
        address1: 'addr1',
        adreese2: 'addr2',
        name_usine: 'factoryNm',
        etrangere: 'chkRc',
        gouvernorat: 'gouvernorat',
        delegation: 'delegation',
        ville: 'ville',
    };
    form = new FormGroup({
        [this.filed.tel_num]: new FormControl(null, [Validators.required]),
        [this.filed.codepostale]: new FormControl({value: null, disabled: true}, [
            Validators.required,
        ]),
        [this.filed.address1]: new FormControl({value: null, disabled: true}, [
            Validators.required,
        ]),
        [this.filed.adreese2]: new FormControl(null),
        [this.filed.name_usine]: new FormControl(null, [Validators.required]),
        [this.filed.fax]: new FormControl(null),
        [this.filed.etrangere]: new FormControl('N', [Validators.required]),
        [this.filed.gouvernorat]: new FormControl(null, [Validators.required]),
        [this.filed.delegation]: new FormControl(null, [Validators.required]),
        [this.filed.ville]: new FormControl(null, [Validators.required]),
    });

    constructor(
        private dialog: MatDialogRef<AddDialogUsineComponent, { data: any }>,
        private cdref: ChangeDetectorRef
    ) {
    }

    getFormControl(key: string): FormControl {
        return this.form.controls[key] as FormControl;
    }

    ngOnInit(): void {
        this.form.get(this.filed.etrangere).valueChanges.subscribe((d) => {
            if (d == 'Y') {
                this.form.get(this.filed.gouvernorat).clearValidators();
                this.form.get(this.filed.ville).clearValidators();
                this.form.get(this.filed.delegation).clearValidators();
                this.form.updateValueAndValidity();
            }
        });
    }

    onSuccessAdd() {
        const gouv = this.selectCodepostalComponent?.selectGouvernoratComponent
            ?.matselcet?.value;
        const d = this.selectCodepostalComponent?.selectDelegationComponent?.mat
            ?.value;
        const v = this.selectCodepostalComponent?.selectVilleBygouvandDelComponent
            ?.matselect?.value;
        this.form.get(this.filed.gouvernorat).setValue(gouv);
        this.form.get(this.filed.delegation).setValue(d);
        this.form.get(this.filed.ville).setValue(v);

        this.form.markAllAsTouched();
        if (this.form.valid) {
            const data = this.form.getRawValue();

            this.dialog.close({
                data: data,
            });
        }
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    get(dta: any) {

    }
}
